import PropTypes from 'prop-types';

/**
 * AddToHomeScreenIcon
 *
 * Plus-in-rounded-square glyph used in the "Add to Home Screen" install steps
 * (PWA conversion overlay + web-signup install screen).
 */
export const AddToHomeScreenIcon = ({ size = 28, color = '#333' }) => (
  <svg width={size} height={size} viewBox="0 0 256 256" fill="none">
    <rect
      x="40"
      y="40"
      width="176"
      height="176"
      rx="24"
      stroke={color}
      strokeWidth="16"
      fill="none"
    />
    <line
      x1="128"
      y1="88"
      x2="128"
      y2="168"
      stroke={color}
      strokeWidth="16"
      strokeLinecap="round"
    />
    <line
      x1="88"
      y1="128"
      x2="168"
      y2="128"
      stroke={color}
      strokeWidth="16"
      strokeLinecap="round"
    />
  </svg>
);

AddToHomeScreenIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default AddToHomeScreenIcon;
